import { graphSelection } from './';

// These are overridden by the derived focus properties of DesignTokens if they exist.
export const graphFocus = (theme, parameters) => {
  switch (theme.baseThemeName) {
    case 'high-contrast':
      {
        return {
          lineColor: graphSelection(theme, parameters).lineColor,
          lineStyle: 'dotted',
          lineThickness: '5px'
        };
      }
    default:
      {
        return {
          lineColor: graphSelection(theme, parameters).lineColor,
          lineStyle: 'dashed',
          lineThickness: '1px'
        };
      }
  }
};
//# sourceMappingURL=graphFocus.js.map